export default __webpack_public_path__ + "static/Cooked_Meat-09a4f1c0751a8122e055e61792af98d4.png";